<script setup>
const { columns = 4, title } = defineProps({
    columns: {
        type: Number,
        required: false,
    },
    title: {
        type: String,
        required: false,
    },
});
</script>

<template>
    <div v-if="title" class="border-main relative mt-4 rounded-lg border p-4">
        <div
            class="absolute -top-4 left-2 rounded bg-indigo-600 px-3 py-0.5 text-sm text-white shadow"
            style="line-height: 1.25rem"
        >
            {{ title }}
        </div>

        <div
            class="grid grid-cols-1 gap-4"
            :class="{
                'md:grid-cols-2': columns === 2,
                'md:grid-cols-2 lg:grid-cols-3': columns === 3,
                'md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4': columns === 4,
                'md:grid-cols-2 xl:grid-cols-4 2xl:grid-cols-7': columns === 7,
            }"
        >
            <slot />
        </div>
    </div>

    <div
        v-else
        class="grid grid-cols-1 gap-4"
        :class="{
            'md:grid-cols-2': columns === 2,
            'md:grid-cols-2 lg:grid-cols-3': columns === 3,
            'md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4': columns === 4,
            'md:grid-cols-2 xl:grid-cols-4 2xl:grid-cols-7': columns === 7,
        }"
    >
        <slot />
    </div>
</template>
